import { Outlet } from "react-router-dom";
import { Box, Hidden, Toolbar } from "@mui/material";
import { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import sizeConfigs from "../../configs/sizeConfigs";
import colorConfigs from "../../configs/colorConfigs";
import { useSessao } from "../../redux/sessao/sessaoHooks";
import LoginPage from "../../pages/Login/LoginPage";
import Drawer from "../common/Drawer";
import Copyright from "./Copyrigth";
import { useSelector } from "react-redux";
import { RootAppState } from "../../redux/store";
import Header from "./Header";

const MainLayout = () => {
  const [openSlideBar, setOpenSliderBar] = useState(false);
  const classes = useStyles();
  const [sessao] = useSessao();
  const [autorizado, setAutorizado] = useState(true);
  const { appState } = useSelector((state: RootAppState) => state.appState);

  const handleDrawerToggle = () => {
    setOpenSliderBar(!openSlideBar);
  };

  useEffect(() => {
    if (!sessao.tokenJWT) {
      setAutorizado(false);
    } else {
      setAutorizado(true);
    }
  }, [sessao]);

  if (!autorizado) {
    return <LoginPage />;
  }

  return (
    <div>
      <Box sx={{ display: "flex" }}>
        <Hidden mdUp>
          <Header
            drawerOpen={openSlideBar}
            onDrawerToggle={handleDrawerToggle}
          />
        </Hidden>

        <Hidden mdDown>
          <Box component="nav">
            <Drawer
              open={openSlideBar}
              onOpen={() => setOpenSliderBar(true)}
              onClose={() => setOpenSliderBar(false)}
            />
          </Box>
        </Hidden>

        {openSlideBar && (
          <Hidden mdUp>
            <Box component="nav">
              <Drawer
                open={openSlideBar}
                onOpen={() => setOpenSliderBar(true)}
                onClose={() => setOpenSliderBar(false)}
              />
            </Box>
          </Hidden>
        )}

        <Box
          component="main"
          sx={{
            flexGrow: 1,
            p: 2,
            width: `calc(100% - ${sizeConfigs.sidebar.width})`,
            minHeight: "97.3vh",
            backgroundColor: colorConfigs.mainBg,
          }}
        >
          <Hidden mdUp>
            <Toolbar />
          </Hidden>
          <Outlet />
        </Box>
      </Box>

      {appState !== "NIL" && (
        <footer className={classes.footer}>
          <Copyright textColor={"#065c3e"} />
        </footer>
      )}
    </div>
  );
};

const useStyles = makeStyles({
  body: {
    "@media (max-width: 768px)": {
      height: "100vh",
      width: "100vw",
      padding: "15%",
    },
  },
  footer: {
    bottom: 0,
    background: colorConfigs.mainBg,
  },
});

export default MainLayout;
